export async function loadProductSection(sectionId: string, handle:string) : Promise<string> {
	const root = (window as any)?.Shopify?.routes?.root || "/";
	const normalizedRoot = root.endsWith("/") ? root : `${root}/`;
	const url = new URL(`${normalizedRoot}products/${handle}`, window.location.origin);
	url.searchParams.set("section_id", sectionId);

	const response = await fetch(url.toString());
  const data = await response.text();
  return data;
}

// Trasforma URLSearchParams (location.search) in una stringa filters per Algolia
export function shopifyFiltersToAlgoliaFilters(
  params: URLSearchParams,
  opts?: { collectionHandle?: string }
): string[] {
  const clauses: string[] = [];

  // // forza la collection corrente
  // if (opts?.collectionHandle) {
  //   clauses.push(`collections:'${escapeAlgoliaValue(opts.collectionHandle)}'`);
  // }

  // raccogli tutte le chiavi 'filter.*'
  const keys = Array.from(params.keys()).filter(k => k.startsWith("filter."));

  // per evitare doppioni, lavoriamo per chiave unica
  const uniqKeys = Array.from(new Set(keys));

  for (const key of uniqKeys) {
    const valuesRaw = params.getAll(key) // param ripetuto
      .flatMap(v => v.split(","))
      .map(v => v.trim())
      .filter(Boolean);

    if (!valuesRaw.length) continue;

    const parts = key.split("."); // es. ["filter","v","option","taglia"] o ["filter","v","price","gte"]
    const scope = parts[1];       // "p" | "v"
    const attr = parts[2];

    // helper per OR tra più valori
    const orGroup = (exprs: string[]) =>
      exprs.length > 1 ? `(${exprs.join(" OR ")})` : exprs[0];

    switch (attr) {
      // --- Product facets ---
      case "vendor": {
        const exprs = valuesRaw.map(v => `vendor:'${escapeAlgoliaValue(v)}'`);
        clauses.push(orGroup(exprs));
        break;
      }
      case "product_type": {
        const exprs = valuesRaw.map(v => `product_type:'${escapeAlgoliaValue(v)}'`);
        clauses.push(orGroup(exprs));
        break;
      }
      case "tag": { // Shopify -> Algolia spesso 'tags'
        const exprs = valuesRaw.map(v => `tags:'${escapeAlgoliaValue(v)}'`);
        clauses.push(orGroup(exprs));
        break;
      }

      // --- Variant option ---
      case "option": {
        // filter.v.option.<name>=val1,val2
        const optionName = parts[3]; // es. "taglia"
        if (!optionName) break;
        const exprs = valuesRaw.map(v =>
          `options.${optionName}:'${escapeAlgoliaValue(v)}'`
        );
        clauses.push(orGroup(exprs));
        break;
      }

      // --- Price range (numeric) ---
      case "price": {
        const op = parts[3]; // "gte" | "lte" | "gt" | "lt" ...
        for (const v of valuesRaw) {
          const num = Number(v.replace(",", "."));
          if (!Number.isFinite(num)) continue;
          // Algolia filters supporta confronti numerici nel parametro "filters"
          // es: price >= 50 AND price <= 75
          const cmp =
            op === "gte" ? ">=" :
              op === "lte" ? "<=" :
                op === "gt" ? ">" :
                  op === "lt" ? "<" : undefined;
          if (cmp) clauses.push(`price ${cmp} ${num}`);
        }
        break;
      }

      // --- Metafields: filter.p.m.<ns>.<key>=val ---
      case "m": {
        const ns = parts[3];
        const mkey = parts[4];
        if (!ns || !mkey) break;
        const exprs = valuesRaw.map(v =>
          `meta.${ns}.${mkey}:'${escapeAlgoliaValue(v)}'`
        );
        clauses.push(orGroup(exprs));
        break;
      }

      // --- Fallback: passa-through qualunque altro attributo ---
      // default: {
      //   // esempio: filter.v.availability=1  -> availability:'1'
      //   const name = parts.slice(2).join("."); // "availability" o "foo.bar"
      //   const exprs = valuesRaw.map(v =>
      //     isNumeric(v) ? `${name} = ${Number(v)}` : `${name}:'${escapeAlgoliaValue(v)}'`
      //   );
      //   clauses.push(orGroup(exprs));
      //   break;
      // }
    }
  }

  return clauses;
}

function escapeAlgoliaValue(v: string) {
  // sfugge gli apici per l'uso tra singoli apici
  return v.replace(/'/g, "\\'");
}
function isNumeric(v: string) {
  return v.trim() !== "" && Number.isFinite(Number(v.replace(",", ".")));
}
